import { useState } from "react";
import api from "@/lib/api";
import { Stethoscope, Loader2, CheckCircle2, XCircle } from "lucide-react";

const Riga = ({ label, ok, dettaglio }) => (
  <li className="flex items-start gap-2.5 py-1.5">
    {ok ? <CheckCircle2 className="w-4 h-4 text-[#276749] mt-0.5 shrink-0" /> : <XCircle className="w-4 h-4 text-[#9b2c2c] mt-0.5 shrink-0" />}
    <div className="min-w-0">
      <span className="text-sm text-[#1A2B4A]">{label}</span>
      {dettaglio && <div className="text-[11px] text-[#4a5568] break-words">{dettaglio}</div>}
    </div>
  </li>
);

// Diagnostica della lettura AI: dice esattamente quale pezzo non risponde.
export default function DiagnosticaAI() {
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);

  const esegui = async () => {
    setBusy(true); setRes(null);
    try {
      const { data } = await api.get("/diagnostica/estrazione");
      setRes(data);
    } catch (e) {
      setRes({ errore_chiamata: e?.response?.status ? `HTTP ${e.response.status}` : (e?.message || "nessuna risposta dal server") });
    } finally { setBusy(false); }
  };

  const j = res?.coda?.ultimo_job;

  return (
    <div data-testid="diagnostica-ai" className="mt-6 bg-white border border-[#1A2B4A]/10 rounded-sm p-4">
      <div className="flex items-center justify-between gap-4 mb-2">
        <div className="flex items-center gap-2">
          <Stethoscope className="w-5 h-5 text-[#1A2B4A]" />
          <h3 className="font-serif text-xl text-[#1A2B4A]">Diagnostica lettura documenti</h3>
        </div>
        <button data-testid="diagnostica-run" onClick={esegui} disabled={busy}
          className="inline-flex items-center gap-2 text-sm bg-[#1A2B4A] text-white px-4 py-2 rounded-sm hover:bg-[#22345c] disabled:opacity-50">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Stethoscope className="w-4 h-4" />} Esegui verifica
        </button>
      </div>
      <p className="text-sm text-[#4a5568]">Controlla in tempo reale il motore di lettura: se qualcosa non funziona qui vedi cosa e puoi inviarmi lo schermo.</p>

      {res && (
        <ul className="mt-4 divide-y divide-[#1A2B4A]/5" data-testid="diagnostica-risultato">
          {res.errore_chiamata ? (
            <Riga ok={false} label="Il server non risponde alla diagnostica" dettaglio={res.errore_chiamata} />
          ) : (
            <>
              <Riga ok={res.worker?.ok} label="Motore di lettura attivo"
                dettaglio={res.worker?.ultimo_errore ? `errore: ${res.worker.ultimo_errore}`
                  : res.worker?.ultimo_battito_secondi == null ? "mai partito su questo server"
                  : `ultimo battito ${res.worker.ultimo_battito_secondi}s fa · documenti in lavorazione: ${res.worker.in_lavorazione}`} />
              <Riga ok={res.gridfs?.ok} label="Archivio temporaneo dei file" dettaglio={res.gridfs?.errore} />
              <Riga ok={res.ai?.ok} label="Servizio AI di lettura"
                dettaglio={res.ai?.errore || `risposta in ${res.ai?.secondi}s`} />
              <Riga ok={(res.coda?.job_in_corso ?? 0) < 5} label={`Letture in corso adesso: ${res.coda?.job_in_corso ?? 0}`} />
              {j && (
                <Riga ok={j.stato === "completo"} label={`Ultima lettura: ${j.stato} (${j.fatti}/${j.totale})${j.secondi ? ` in ${j.secondi}s` : ""}`}
                  dettaglio={`avviata ${j.creato} · stato file: ${(j.stati_file || []).join(", ")}${j.errori?.length ? ` · errori: ${j.errori.join(" | ")}` : ""}`} />
              )}
            </>
          )}
        </ul>
      )}
    </div>
  );
}
